import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const convertToDateString = (dateObj) => {
  const dateString = dateObj.toLocaleDateString('en-US', {
    weekday: 'long', // "Monday"
    year: 'numeric', // "2024"
    month: 'long', // "June"
    day: 'numeric' // "25"
  });
  return dateString;
};

export const formatDate = (dateString) => {
  const dateObj = new Date(dateString);
  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export const convertTo24HourFormat = (timeString) => {
  const [time, modifier] = timeString.split(' ');
  let [hours, minutes] = time.split(':');

  if (modifier === 'PM' && hours !== '12') {
    hours = parseInt(hours, 10) + 12;
  }
  if (modifier === 'AM' && hours === '12') {
    hours = '00';
  }

  return `${hours}:${minutes}:00`;
};

export const convertTo12HourFormat = (timeString) => {
  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  return format(date, 'h:mm a'); // Format to 12-hour format with AM/PM
};

// Covert Mon Sep 09 1991 00:00:00 GMT-0700 (Pacific Daylight Time) => '1991-09-09T07:00:00.000Z'
export const convertToISODateString = (dateObj) => {
  const dateObject = new Date(dateObj);
  const isoDateString = dateObject.toISOString();
  return isoDateString;
};

// Convert a Date object to ISO 8601 format with milliseconds and UTC timezone
export const convertToISODateTimeString = (dateObj) => {
  const dateObject = new Date(dateObj);
  return dateObject.toISOString();
};

export const getTimeWithTimeZone = (
  utcDateTimeString,
  timeZone,
  format = 'h:mm a'
) => {
  const dateObj = new Date(utcDateTimeString);
  const formattedDate = formatInTimeZone(dateObj, timeZone, format);
  return formattedDate;
};

export const getDateWithTimeZone = (
  utcDateTimeString,
  timeZone,
  format = 'MMM d, yyyy'
) => {
  const dateObj = new Date(utcDateTimeString);
  const formattedDate = formatInTimeZone(dateObj, timeZone, format);
  return formattedDate;
};

export const getLocalDateFromDate = (date) => {
  const localDate = parseISO(date);
  return format(localDate, 'MMMM d, yyyy');
};

export const formatDateAndTime = (dateString) => {
  const dateObj = new Date(dateString);
  return format(dateObj, 'MMM d, yyyy - h:mmaa');
};

export const formatLocalDate = (dateString) => {
  const dateObj = new Date(dateString);
  return format(dateObj, 'MMM d, yyyy');
};

export const formatLocalDateWithDayOfWeek = (dateString) => {
  const dateObj = new Date(dateString);
  return format(dateObj, 'EEE, MMM d, yyyy');
};

export const formatLocalTime = (dateString) => {
  const dateObj = new Date(dateString);
  return format(dateObj, 'h:mmaa');
};

// 2025-03-26T07:00:00.000Z => 2025-03-26
// Use this function because depending on the timezone, the date could be different
export const extractDateFromISODateTimeString = (isoDateTimeString) => {
  const dateObj = new Date(isoDateTimeString);
  return format(dateObj, 'yyyy-MM-dd', { timeZone: 'UTC' });
};
